import React from "react";

export interface IconPdfProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const IconPdf: React.FC<IconPdfProps> = ({
  width = 26,
  height = 34,
  fill = "#006231",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 26 34"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M12.0793 17.0066C11.7473 15.9441 11.7539 13.8922 11.9465 13.8922C12.5043 13.8922 12.4512 16.3426 12.0793 17.0066ZM11.9664 20.141C11.4551 21.4824 10.8176 23.0164 10.0805 24.3047C11.2957 23.8398 12.6703 23.1625 14.2574 22.8504C13.4141 22.2129 12.6039 21.2965 11.9664 20.141ZM5.71758 28.4285C5.71758 28.4816 6.59414 28.0699 8.03516 25.759C7.59023 26.1773 6.10273 27.3859 5.71758 28.4285ZM16.4688 10.625H25.5V32.4062C25.5 33.2895 24.7895 34 23.9062 34H1.59375C0.710547 34 0 33.2895 0 32.4062V1.59375C0 0.710547 0.710547 0 1.59375 0H14.875V9.03125C14.875 9.90781 15.5922 10.625 16.4688 10.625ZM15.9375 22.0336C14.6094 21.2234 13.7262 20.1078 13.102 18.4609C13.4008 17.2324 13.8723 15.3664 13.5137 14.1977C13.2016 12.2453 10.698 12.4379 10.3395 13.7461C10.0074 14.9613 10.3129 16.6746 10.8773 18.8594C10.107 20.6922 8.97148 23.1492 8.16797 24.557C8.16133 24.557 8.16133 24.5637 8.15469 24.5637C6.35508 25.4867 3.26719 27.5187 4.53555 29.0793C4.90742 29.5375 5.59805 29.7434 5.96328 29.7434C7.15195 29.7434 8.33398 28.548 10.0207 25.6395C11.734 25.075 13.6133 24.3711 15.2668 24.0988C16.7078 24.8824 18.3945 25.3937 19.5168 25.3937C21.4559 25.3937 21.5887 23.2687 20.825 22.5117C19.902 21.6086 17.2191 21.8676 15.9375 22.0336ZM25.0352 6.97266L18.5273 0.464844C18.2285 0.166016 17.8234 0 17.3984 0H17V8.5H25.5V8.09492C25.5 7.67656 25.334 7.27148 25.0352 6.97266ZM20.1145 23.9262C20.3867 23.7469 19.9484 23.1359 17.2723 23.3285C19.7359 24.3777 20.1145 23.9262 20.1145 23.9262Z" />
  </svg>
);
